(function () {
  function initProductInfoTabs(root) {
    if (!root || root.dataset.tabsReady === 'true') return;
    root.dataset.tabsReady = 'true';

    var tabs = root.querySelectorAll('[data-product-info-tab]');
    var panels = root.querySelectorAll('[data-product-info-panel]');

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var target = tab.getAttribute('data-product-info-tab');

        tabs.forEach(function (btn) {
          var isActive = btn === tab;
          btn.classList.toggle('is-active', isActive);
          btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });

        panels.forEach(function (panel) {
          var isActive = panel.getAttribute('data-product-info-panel') === target;
          panel.classList.toggle('is-active', isActive);
          if (isActive) {
            panel.removeAttribute('hidden');
          } else {
            panel.setAttribute('hidden', '');
          }
        });
      });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-product-info-tabs]').forEach(initProductInfoTabs);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
